<template>
  <LayoutDashboard>
    <h5 class="font-weight-bold m-0">
      Dashboard
    </h5>
    <small class="text-info font-weight-bold">
      Dashboard
    </small>

    <Filters
      class="mt-3"
      :filters="filters"
      :is-apply="isApply"
      @updateApply="updateApply"
      @updateDate="updateDate"
      @updateEmployee="updateEmployee"
    />

    <TotalSubmissions
      class="mt-3"
      :filters="filters"
      :is-apply="isApply"
    />

    <div class="row mt-3">
      <div class="col-12 col-md-4">
        <TotalSubmitter
          class="mt-3"
          :filters="filters"
          :is-apply="isApply"
        />
      </div>
      <div class="col-12 col-md-8">
        <Department
          class="mt-3"
          :filters="filters"
          :is-apply="isApply"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-md-4">
        <AverageContractor
          class="mt-3"
          :filters="filters"
          :is-apply="isApply"
        />
      </div>
      <div class="col-12 col-md-4">
        <RiskLevel
          class="mt-3"
          :filters="filters"
          :is-apply="isApply"
        />
      </div>
      <div class="col-12 col-md-4">
        <TestResult
          class="mt-3"
          :filters="filters"
          :is-apply="isApply"
        />
      </div>
    </div>

    <TotalCase
      class="mt-3"
      :filters="filters"
      :is-apply="isApply"
    />

    <CaseResult
      class="mt-3"
      :filters="filters"
      :is-apply="isApply"
    />
  </LayoutDashboard>
</template>

<script>
import { sub, lastDayOfMonth, startOfMonth } from 'date-fns'
import LayoutDashboard from '@/components/LayoutDashboard'
import TotalSubmissions from './Dashboard/TotalSubmissions'
import TotalSubmitter from './Dashboard/TotalSubmitter'
import Department from './Dashboard/Department'
import RiskLevel from './Dashboard/RiskLevel'
import TestResult from './Dashboard/TestResult'
import CaseResult from './Dashboard/CaseResult'
import AverageContractor from './Dashboard/AverageContractor'
import Filters from './Dashboard/Filters'
import TotalCase from './Dashboard/TotalCase'

export default {
  components: {
    LayoutDashboard,
    TotalSubmissions,
    TotalSubmitter,
    Department,
    RiskLevel,
    TestResult,
    CaseResult,
    AverageContractor,
    Filters,
    TotalCase
  },

  data: () => ({
    filters: {
      period: 'daily',
      startDate: sub(new Date(), { days: 30 }),
      endDate: new Date(),
      risk: [],
      employee: [],
      organization: [],
      workLocation: [],
      contractors: []
    },
    isApply: false
  }),

  methods: {
    updateApply (isReset) {
      if (isReset) {
        this.filters = {
          period: 'daily',
          startDate: sub(new Date(), { days: 30 }),
          endDate: new Date(),
          risk: [],
          employee: [],
          organization: [],
          workLocation: [],
          contractors: []
        }
      }
      if (this.filters.period === 'monthly') {
        this.filters.startDate = startOfMonth(this.filters.startDate)
        this.filters.endDate = lastDayOfMonth(this.filters.endDate)
      }
      this.isApply = !this.isApply
    },
    updateDate (date) {
      this.filters.startDate = date[0]
      this.filters.endDate = date[1]
    },
    updateEmployee (employeeIndex) {
      this.filters.employee = []
      if (employeeIndex.length) {
        this.filters.employee = [false, false]
        for (let i = 0; i < employeeIndex.length; i++) {
          this.filters.employee[employeeIndex[i]] = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border: 0;
  border-radius: 12px;
}
</style>
